export const BRAND_NAME = "BS Fiber Product";
export const BRAND_TAGLINE = "Stock Management ERP";
export const BRAND_LOGO_URL = "https://customer-assets-eiarnc6j.emergentagent.net/job_inventory-pro-857/artifacts/axbd4oox_WhatsApp%20Image%202026-07-15%20at%2010.03.14%20PM.jpeg";

// Signature product showcase for the login page
export const SHOWCASE_IMAGES = [
    {
        url: "https://customer-assets-eiarnc6j.emergentagent.net/job_inventory-pro-857/artifacts/obptcro2_HHFZ9380%20-%20Copy.JPG",
        title: "Serene Grand Fountain",
        caption: "Fiber craftwork · Hospitality project",
    },
    {
        url: "https://customer-assets-eiarnc6j.emergentagent.net/job_inventory-pro-857/artifacts/ykyz3p5j_IMG_1308.PNG",
        title: "Divine Krishna Fountain",
        caption: "Fiber craftwork · Garden collection",
    },
];

